<template>
  <div class="not-found-page">
    <b-container>
      <b-row class="not-found-row">
        <!-- Illustration -->
        <b-col lg="6" class="not-found-illustration">
          <svg
            width="100%"
            max-width="450"
            viewBox="0 0 450 450"
            xmlns="http://www.w3.org/2000/svg"
          >
            <!-- Background circle -->
            <circle cx="225" cy="225" r="200" fill="#E8F1F8" opacity="0.8" />

            <!-- Light 404 background -->
            <text
              x="120"
              y="310"
              font-size="200"
              font-weight="300"
              text-anchor="middle"
              fill="#D9E5F0"
              opacity="0.6"
            >
              4
            </text>
            <text
              x="330"
              y="310"
              font-size="200"
              font-weight="300"
              text-anchor="middle"
              fill="#D9E5F0"
              opacity="0.6"
            >
              4
            </text>

            <!-- Yellow circle top left -->
            <circle cx="130" cy="110" r="20" fill="#F8C617" />

            <!-- Gray circle top right -->
            <circle cx="310" cy="130" r="25" fill="#7D8998" opacity="0.6" />

            <!-- Blue circle bottom left -->
            <circle cx="130" cy="340" r="18" fill="#2152FF" />

            <!-- Yellow circle bottom right -->
            <circle cx="340" cy="320" r="22" fill="#F8C617" opacity="0.8" />

            <!-- Main 404 numbers in light gray -->
            <text
              x="140"
              y="280"
              font-size="140"
              font-weight="400"
              fill="#E8E8E8"
              opacity="0.5"
            >
              4
            </text>

            <!-- Center magnifying glass -->
            <g transform="translate(225, 215)">
              <!-- Magnifying glass handle -->
              <line
                x1="35"
                y1="35"
                x2="65"
                y2="65"
                stroke="#435469"
                stroke-width="8"
                stroke-linecap="round"
              />

              <!-- Circle -->
              <circle
                cx="0"
                cy="0"
                r="55"
                fill="none"
                stroke="#435469"
                stroke-width="8"
              />

              <!-- Inner light background -->
              <circle cx="0" cy="0" r="48" fill="#ffffff" opacity="0.9" />

              <!-- Question mark -->
              <text
                x="0"
                y="15"
                font-size="70"
                font-weight="700"
                text-anchor="middle"
                fill="#435469"
              >
                ?
              </text>
            </g>
          </svg>
        </b-col>

        <!-- Content -->
        <b-col lg="6" class="not-found-content">
          <div class="not-found-text-block">
            <!-- Error Code -->
            <h1 class="not-found-code">404</h1>

            <!-- Main Title -->
            <h2 class="not-found-title">Page Not Found</h2>

            <!-- Description -->
            <p class="not-found-description">
              Sorry, the page you're looking for doesn't exist. It might have
              been moved or deleted.
            </p>

            <!-- Action Buttons -->
            <div class="not-found-buttons">
              <router-link to="/" class="btn btn-primary text-white align-items-center">
                <i class="fas fa-home mr-2"></i>Back to Home
              </router-link>
            </div>
          </div>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
export default {
  name: "not-found",
  methods: {
    goBack() {
      this.$router.go(-1);
    },
  },
};
</script>

<style scoped>
/* ============================================
   MAIN CONTAINER
   ============================================ */
.not-found-page {
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #f8f9fa;
  padding: 40px 0;
}

.not-found-row {
  display: flex;
  align-items: center;
  width: 100%;
}

/* ============================================
   ILLUSTRATION SECTION
   ============================================ */
.not-found-illustration {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 2rem;
  padding: 0 1rem;
}

.not-found-illustration svg {
  max-width: 100%;
  height: auto;
  filter: drop-shadow(0 4px 15px rgba(0, 0, 0, 0.08));
}

/* ============================================
   CONTENT SECTION
   ============================================ */
.not-found-content {
  padding: 0 1.5rem;
}

.not-found-text-block {
  width: 100%;
}

/* ============================================
   TYPOGRAPHY
   ============================================ */
.not-found-code {
  font-size: 48px;
  font-weight: 700;
  color: #192534 !important;
  margin: 0 0 8px 0;
  line-height: 1.2;
  letter-spacing: -0.5px;
}

.not-found-title {
  font-size: 32px;
  font-weight: 700;
  color: #192534 !important;
  margin: 0 0 16px 0;
  line-height: 1.3;
}

.not-found-description {
  font-size: 16px;
  font-weight: 400;
  color: #8a92a6 !important;
  margin: 0 0 32px 0;
  line-height: 1.6;
}

/* ============================================
   BUTTONS
   ============================================ */
.not-found-buttons {
  display: flex;
  gap: 12px;
  align-items: center;
}

.btn-home,
.btn-back {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 10px 24px;
  font-size: 16px;
  font-weight: 600;
  border-radius: 5px;
  cursor: pointer;
  transition: all 0.3s ease;
  text-decoration: none;
  border: none;
  white-space: nowrap;
}

.btn-home {
  background-color: #435469 !important;
  color: #ffffff !important;
  border: 1px solid #435469 !important;
}

.btn-home:hover {
  background-color: #354150;
  border-color: #354150;
  transform: translateY(-2px);
  box-shadow: 0 6px 12px rgba(67, 84, 105, 0.25);
}

.btn-home i {
  font-size: 14px;
}

.btn-back {
  background-color: #ffffff !important;
  color: #192534 !important;
  border: 1px solid #d1d5db !important;
}

.btn-back:hover {
  background-color: #f3f4f6;
  border-color: #9ca3af;
  transform: translateY(-2px);
  box-shadow: 0 6px 12px rgba(0, 0, 0, 0.08);
}

.btn-back i {
  font-size: 14px;
}

/* ============================================
   RESPONSIVE DESIGN
   ============================================ */
@media (max-width: 992px) {
  .not-found-illustration {
    margin-bottom: 2.5rem;
  }

  .not-found-code {
    font-size: 42px;
  }

  .not-found-title {
    font-size: 28px;
  }
}

@media (max-width: 768px) {
  .not-found-page {
    padding: 20px 0;
  }

  .not-found-row {
    flex-direction: column-reverse;
  }

  .not-found-illustration {
    margin-bottom: 2rem;
  }

  .not-found-content {
    padding: 0 1rem;
  }

  .not-found-code {
    font-size: 36px;
  }

  .not-found-title {
    font-size: 24px;
  }

  .not-found-description {
    font-size: 15px;
  }

  .not-found-buttons {
    flex-wrap: wrap;
  }

  .btn-home,
  .btn-back {
    flex: 1;
    min-width: 140px;
    justify-content: center;
    padding: 12px 20px;
  }
}

@media (max-width: 576px) {
  .not-found-page {
    padding: 15px 0;
  }

  .not-found-illustration {
    margin-bottom: 1.5rem;
  }

  .not-found-code {
    font-size: 28px;
    margin-bottom: 6px;
  }

  .not-found-title {
    font-size: 20px;
    margin-bottom: 12px;
  }

  .not-found-description {
    font-size: 14px;
    margin-bottom: 24px;
  }

  .btn-home,
  .btn-back {
    width: 100%;
    padding: 11px 16px;
    font-size: 14px;
    gap: 6px;
  }

  .btn-home i,
  .btn-back i {
    font-size: 13px;
  }
}
</style>
